module.exports = __webpack_public_path__ + "static/img/bg.aeb531b6.png";